export const AIGC_OPTIONS = [
  {
    text: 'All',
    value: '0',
  },
  {
    text: 'Yes',
    value: '1',
  },
  {
    text: 'No',
    value: '2',
  },
];
